import { render, staticRenderFns } from "./12_treatment.vue?vue&type=template&id=3f789e87"
import script from "./12_treatment.vue?vue&type=script&lang=js"
export * from "./12_treatment.vue?vue&type=script&lang=js"
import style0 from "./12_treatment.vue?vue&type=style&index=0&id=3f789e87&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports